"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.CollectionMode = exports.initBlizzard = void 0;
var environment_1 = require("./environment");
var logger_1 = require("./logger");
var lifecycle_1 = require("./lifecycle");
var logEvent_1 = require("./logEvent");
var frameStart_1 = require("./metadata/frameStart");
var grapheneMetrics_1 = require("./grapheneMetrics");
var reportWebPageOpen_1 = require("./lifecycle/reportWebPageOpen");
var authState_1 = require("./auth/authState");
var timed_1 = require("./util/timed");
var getUploadConfig_1 = require("./network/getUploadConfig");
var clientId_1 = require("./clientId");
var config_1 = require("./config");
var cof_1 = require("./config/cof");
var webSessionId_1 = require("./webSession/webSessionId");
var framesLogQueue_1 = require("./logEvent/queue/framesLogQueue");
var log = (0, logger_1.getLogger)("initBlizzard");
function initBlizzard(args) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (logEvent_1.initCalled) {
        throw new Error("initBlizzard should not be called multiple times");
    }
    log.info("Initializing Blizzard", args);
    (0, logEvent_1.setInitCalled)();
    (0, logger_1.setAnalyticsLoggingEnabled)(Boolean(args.debugLoggingEnabled));
    (0, clientId_1.setCookiesEnabled)(!args.cookiesDisabled, (_a = args.cookiesArgs) === null || _a === void 0 ? void 0 : _a.customDomain, (_b = args.cookiesArgs) === null || _b === void 0 ? void 0 : _b.expireDays);
    (0, framesLogQueue_1.setBatchingConfigs)((_c = args.batchingEnabled) !== null && _c !== void 0 ? _c : false, (_e = (_d = args.batchingArgs) === null || _d === void 0 ? void 0 : _d.fetchFromCof) !== null && _e !== void 0 ? _e : true, (_g = (_f = args.batchingArgs) === null || _f === void 0 ? void 0 : _f.batchSize) !== null && _g !== void 0 ? _g : 20, (_j = (_h = args.batchingArgs) === null || _h === void 0 ? void 0 : _h.flushTimeout) !== null && _j !== void 0 ? _j : 5000);
    (0, webSessionId_1.saveWebSessionIdWhenActive)();
    (0, environment_1.setAppEnvironment)(args.appEnvironment);
    (0, environment_1.setCollectionMode)((_k = args.mode) !== null && _k !== void 0 ? _k : CollectionMode.PROD);
    (0, authState_1.initializeAuthState)((_l = args.clientAuthProvider) !== null && _l !== void 0 ? _l : null);
    (0, grapheneMetrics_1.initGraphene)(args.metricsAppId);
    if (args.lifecycleConfig) {
        (0, lifecycle_1.setLifecycleConfig)(args.lifecycleConfig);
    }
    if (args.userGuid) {
        (0, frameStart_1.setUserGuidPromise)(args.userGuid);
    }
    if (args.tivTransactionId) {
        (0, reportWebPageOpen_1.setTivTransactionIdPromise)(args.tivTransactionId);
    }
    if (args.webClientId) {
        (0, reportWebPageOpen_1.setWebClientIdPromise)(args.webClientId);
    }
    if (args.customConfig) {
        (0, config_1.setCustomConfig)(args.customConfig);
    }
    var initCofPromise = (0, cof_1.initCofConfig)(args.configsClient);
    (0, timed_1.timed)(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, args.tivTransactionId];
                case 1:
                    _a.sent();
                    return [4, args.userGuid];
                case 2:
                    _a.sent();
                    return [4, (0, getUploadConfig_1.tryToGetUploadConfig)()];
                case 3:
                    _a.sent();
                    return [4, initCofPromise];
                case 4:
                    _a.sent();
                    log.info("Blizzard initialized");
                    return [2];
            }
        });
    }); }, {
        metricsName: grapheneMetrics_1.INIT_DURATION_MILLIS
    });
}
exports.initBlizzard = initBlizzard;
var CollectionMode;
(function (CollectionMode) {
    CollectionMode["STAGE"] = "STAGE";
    CollectionMode["PROD"] = "PROD";
})(CollectionMode = exports.CollectionMode || (exports.CollectionMode = {}));
//# sourceMappingURL=initBlizzard.js.map